export interface AutocompleteParams {
  inputValue: string;
  sessionToken?: string;
}

export const autocompleteKeys = {
  all: ['autocomplete'] as const,

  // Location autocomplete
  location: () => [...autocompleteKeys.all, 'location'] as const,
  locationSuggestions: (params: AutocompleteParams) =>
    [...autocompleteKeys.location(), params] as const,

  // Restaurant autocomplete
  restaurant: () => [...autocompleteKeys.all, 'restaurant'] as const,
  restaurantSuggestions: (params: AutocompleteParams) =>
    [...autocompleteKeys.restaurant(), params] as const,
} as const;
